<script setup lang="ts">
  import type { InfoDocumento } from '@/shared/lib';

  defineProps<{
    info: InfoDocumento[];
  }>();
</script>

<template>
  <div class="flex flex-wrap items-start gap-6">
    <div
      v-for="item in info"
      :key="item.label"
      class="flex min-w-0 max-w-full flex-col gap-2"
    >
      <div class="text-left font-semibold">
        {{ item.label }}
      </div>
      <div
        class="flex min-h-12 items-center break-words rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-left"
      >
        {{ item.value }}
      </div>
    </div>
  </div>
</template>
